import React, {useState} from 'react';
import 'firebase'
import firebaseApp from '../Firebase/FirebaseConfig'
//this is bad, move it server side bud



const CodeForm = () => {
    const [successState, setSuccessState] = useState(0)
    const [downloadURL, setDownloadURL] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        // console.log(e.target[0].value)
        const albumCode = e.target[0].value.toString().toUpperCase()
        if (albumCode.length === 7){
            queryCode(albumCode)
            e.target.reset()
        } else {
            setSuccessState(2)
            e.target.reset()
        }
    }

    const displaySuccessState = () => {
        if(successState === 0){
            return(
            <div>
                <h2>Redeem your album here</h2>
                <form id='code-form' onSubmit={handleSubmit}>
                    <label>Enter Download Code</label>
                    <input type='text' className='form-input'></input>
                    <button type='submit' className='submit-button'>Redeem</button>
                </form>
            </div>
            )
        } else if (successState === 1){
            return(
                <div id='code-form'>
                    <h2>Success!</h2>
                    <p>download should start shortly</p>
                    <p>If it doesn't start in the next 10 seconds click <a href={downloadURL}>this link</a></p>
                </div>
            )
        } else if (successState === 2) {
            return(
            <div>
                <h2>Something Went Wrong</h2>
                <form id='code-form' onSubmit={handleSubmit}>
                    <label>Please Try Again</label>
                    <input type='text' className='form-input'></input>
                    <button type='submit' className='submit-button'>Redeem</button>
                </form>
            </div>
            )
        } else {
            return(
                <div>
                    <h2>Checking Code</h2>
                    <p>This should take less than 10 seconds</p>
                </div>
            )
        }
    }

    const queryCode = (albumCode) => {
        const backEnd = 'https://us-central1-download-code-check.cloudfunctions.net/checkCode_RD01'
        // const req = new XMLHttpRequest();
        // req.open('GET', backEnd);
        // req.send(albumCode)
        setSuccessState(3)
        fetch(backEnd, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json;charset=UTF-8"
            },
            body: JSON.stringify({
                code: albumCode
            })
        }).then(res => {
            console.log(res)
            return res.text()})
        .then(res => {
            // console.log(res)
            if(res){
                downloadAlbum(res)
                setSuccessState(1)
            }else{
                setSuccessState(2)
            }
        }).catch(e => {
            console.error('something went wrong: ', e)
            setSuccessState(2)
        })
    }

    const downloadAlbum = (downloadPath) => {
        // const testDownloadPath = "gs://song-download-app-53ca7.appspot.com/testFolder/commercial-small.zip";
        // const realDownloadPath = "gs://song-download-app-53ca7.appspot.com/ScottyMcCreery/PressPreview/Scotty McCreery - Same Truck.zip";
        // console.log(downloadPath)
        firebaseApp.storage()
            .refFromURL(downloadPath)
            .getDownloadURL()
                .then(url=> {
                    const downloadLink = document.createElement("a");
                    downloadLink.href = url;
                    downloadLink.click();
                    setDownloadURL(url)
                })
    }

    return(
        <div >
                {displaySuccessState()}
        </div>
    )
}

export default CodeForm